import { Button, Message, Modal } from '@mairistem/composants';
import { Sens } from '@mairistem/comptabilite';
import { formatMontant, getErrorMessage } from '@mairistem/finances-utils';
import React from 'react';
import { toast } from 'react-toastify';
import STORAGE_KEY from '../../../constants/common/storage';
import { reportEngagement } from '../../../services/projet';
import RadioSegment from '../../common/RadioSegment';
import './CreditPaiementGestionEngagementsModal.css';

interface CreditPaiementGestionEngagementsModalProps {
	engagement: number;
	exercice: string;
	handleClose: () => void;
	identifiantProjet: number;
	type: string;
}

const CreditPaiementGestionEngagementsModal = ({
	engagement,
	exercice,
	handleClose,
	identifiantProjet,
	// biome-ignore lint/correctness/noUnusedFunctionParameters: 	// TODO: A enlever si l'option 2 n'en a pas besoin
	type,
}: CreditPaiementGestionEngagementsModalProps) => {
	const [loading, setLoading] = React.useState(false);
	const [option, setOption] = React.useState(0);
	const identifiantEntiteCompta = sessionStorage.getItem(
		STORAGE_KEY.ID_ENTITE_CPTA,
	);

	const handleConfirm = async () => {
		setLoading(true);
		try {
			if (option === 0) {
				await reportEngagement(
					new URLSearchParams({
						exercice,
						identifiantEntiteCompta,
						identifiantProjet: String(identifiantProjet),
						montantEngagement: String(engagement),
						sens: Sens.DEPENSE,
					}),
				);
				toast.success('Les engagements ont été gérés en reste-à-réaliser');
			} else if (option === 1) {
				toast.success('Les engagements ont été soldés');
			}
			handleClose();
		} catch (e) {
			toast.error(
				getErrorMessage(
					e,
					option === 0
						? 'Erreur lors de la gestion des engagements'
						: 'Erreur lors de la mise en solde des engagements',
				),
			);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal
			closeIcon
			closeOnDimmerClick={false}
			onClose={handleClose}
			open
			size="tiny"
		>
			<Modal.Header content="Gestion des engagements" />
			<Modal.Content>
				<Message color="blue">
					<span className="bold">Montant Engagé: </span>
					{formatMontant(engagement)}
					<br />
					<span className="bold">Exercice: </span>
					{exercice}
				</Message>
				Que souhaitez-vous faire avec les engagements en cours ?
				<RadioSegment
					checked={option === 0}
					content="Gérer en reste-à-réaliser"
					disabled={loading}
					onClick={() => setOption(0)}
					subheader="Les engagements non mandatés seront reportés sur l'exercice suivant"
				/>
				<RadioSegment
					checked={option === 1}
					content="Solder les engagements"
					// TODO: Quand le ticket sera pokérisé, enlever le true
					disabled={true || loading}
					onClick={() => setOption(1)}
					subheader="Les engagements seront annulés et les crédits libérés"
				/>
			</Modal.Content>
			<Modal.Actions>
				<Button content="Annuler" onClick={handleClose} />
				<Button
					content="Confirmer"
					disabled={loading}
					loading={loading}
					onClick={handleConfirm}
					positive
				/>
			</Modal.Actions>
		</Modal>
	);
};

export default CreditPaiementGestionEngagementsModal;
